import React from "react";
import { Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

function Logo() {
  const app = useSelector((state: any) => state.app.data);
  const navigate = useNavigate();

  return (
    <Stack sx={{ cursor: "pointer" }} onClick={() => navigate("/")}>
      <Typography
        sx={{ fontSize: "20px", lineHeight: "22px", fontWeight: 600 }}
      >
        POS Plus
      </Typography>
      {!!app && app.name && (
        <Typography sx={{ fontSize: "12px", lineHeight: "13px" }}>
          {app?.name}
        </Typography>
      )}
    </Stack>
  );
}

export default Logo;
